import { SubmitHandler, useForm } from 'react-hook-form'

import useServerBusiness from '../../api/useServerBusiness'
import useServer from '../../api/useServerMain'
import Input from '../../components/forms/Input'
import TextArea from '../../components/forms/TextArea'
import Button from '../../components/misc/Button'
import Fetching from '../../components/misc/Fetching'
import { useAppSelector } from '../../store/hooks'

const DetailConfig = () => {
  const { denyRoles } = useServer()
  const { control, handleSubmit } = useForm()
  const { business } = useAppSelector((state) => state.init)
  const { editBusiness, isFetching } = useServerBusiness()
  const onSubmit: SubmitHandler<Record<string, string | number | boolean>> = (
    data
  ) => {
    editBusiness(data)
  }
  //  const module_woocommerce = business?.configurationsKey.find(item=>item.key === "module_woocommerce")?.value

  if (isFetching) return <Fetching />
  return (
    <form
      /* w-3/4 */ className="m-auto rounded-lg bg-gray-50 p-5 shadow-md"
      onSubmit={handleSubmit(onSubmit)}
    >
      <h5 className="p-2 pl-0 font-semibold">DNI: {business?.dni}</h5>
      <Input
        control={control}
        defaultValue={business?.name}
        label="Nombre"
        name="name"
      />
      <Input
        control={control}
        defaultValue={business?.promotionalText}
        label="Slogan"
        name="promotionalText"
      />
      {/* <Input
        label="Horario"
        name="openHours"
        control={control}
        defaultValue={business?.openHours}
      /> */}
      <TextArea
        control={control}
        defaultValue={business?.description}
        label="Descripción"
        name="description"
      />
      {/* <TextArea
        label="Pie de comprobante de pago"
        name="footerTicket"
        control={control}
        defaultValue={business?.footerTicket}
      /> */}
      <div className="flex justify-end py-2">
        <Button
          color="slate-600"
          disabled={!denyRoles(['AUDITOR'])}
          name="Actualizar"
          type="submit"
        />
      </div>
    </form>
  )
}

export default DetailConfig
